function getExpiryTime() {
    return Number(localStorage.getItem('access_expiry') || 0)
}

function setExpiryTime(minutesFromNow = 5) {
    const expiry = Date.now() + minutesFromNow * 60 * 1000 - 10000
    localStorage.setItem('access_expiry', expiry.toString())
}

function setUserTheme(mode) {
    localStorage.setItem('user_theme', mode)
     window.dispatchEvent(new CustomEvent('themeChange', { detail: mode }))
}
function getUserTheme() {
    return localStorage.getItem('user_theme')
}

function setGuestUser(userMode) {
    localStorage.setItem('isGuest', userMode)
}

function getUserLanguage() {
    return localStorage.getItem('app_language')
}

function setUserLanguage(userLanguage) {
    localStorage.setItem('app_language', userLanguage)
}

function setShowInviteLangPopup(value) {
    localStorage.setItem('showInviteLangPopup',value ? '1' : '0' )
}
function getShowInviteLangPopup() {
   return localStorage.getItem('showInviteLangPopup')=== '1'
}

function getGuestUser() {
    return localStorage.getItem('isGuest')
}

function setRecaptcha(token) {
    localStorage.setItem('recaptcha_token', token)
}

function getRecaptcha() {
    return localStorage.getItem('recaptcha_token')
}

// Recent searches helpers
const RECENT_SEARCHES_KEY = 'recent_searches'

function getRecentSearches(limit = 10) {
    try {
        const raw = localStorage.getItem(RECENT_SEARCHES_KEY)
        const parsed = raw ? JSON.parse(raw) : []
        if (!Array.isArray(parsed)) return []
        return parsed.slice(0, limit)
    } catch (_) {
        return []
    }
}

function addRecentSearch(query, limit = 10) {
    const trimmed = String(query || '').trim()
    if (!trimmed) return
    try {
        const current = getRecentSearches(limit)
        const withoutDuplicate = current.filter(
            (q) => q.toLowerCase() !== trimmed.toLowerCase()
        )
        const next = [trimmed, ...withoutDuplicate].slice(0, limit)
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next))
    } catch (_) {
        // no-op
    }
}

function clearRecentSearches() {
    try {
        localStorage.removeItem(RECENT_SEARCHES_KEY)
    } catch (_) {
        // no-op
    }
}

function removeRecentSearch(query, limit = 10) {
    const trimmed = String(query || '').trim()
    if (!trimmed) return
    try {
        const current = getRecentSearches(limit)
        const next = current.filter(
            (q) => q.toLowerCase() !== trimmed.toLowerCase()
        )
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next))
    } catch (_) {
        // no-op
    }
}
// Notification settings utilities
export const getNotificationSetting = () => {
    const stored = localStorage.getItem('notificationsEnabled')
    return stored !== null ? JSON.parse(stored) : true // Default to true if no stored value
}

export const setNotificationSetting = (enabled) => {
    localStorage.setItem('notificationsEnabled', JSON.stringify(enabled))
}

export const clearNotificationSetting = () => {
    localStorage.removeItem('notificationsEnabled')
}

export const isGatePublishEnabled = () => {
    if (typeof window === 'undefined') return false
    
    // Clean up legacy typo key ENABLE_GET_PUBLISH if present
    if (localStorage.getItem('ENABLE_GET_PUBLISH') !== null) {
        if (localStorage.getItem('ENABLE_GATE_PUBLISH') === null) {
            localStorage.setItem('ENABLE_GATE_PUBLISH', localStorage.getItem('ENABLE_GET_PUBLISH'))
        }
        localStorage.removeItem('ENABLE_GET_PUBLISH')
    }

    let stored = localStorage.getItem('ENABLE_GATE_PUBLISH')
    if (stored === null) {
        const defaultValue = true
        stored = String(defaultValue)
        try {
            localStorage.setItem('ENABLE_GATE_PUBLISH', stored)
        } catch (e) {
            console.error('Failed to set ENABLE_GATE_PUBLISH in localStorage', e)
        }
    }
    return stored === 'true'
}

if (typeof window !== 'undefined') {
    try {
        isGatePublishEnabled()
    } catch (_) {}
}

export const setGatePublishEnabled = (enabled) => {
    localStorage.setItem('ENABLE_GATE_PUBLISH', String(enabled))
}

export const getLastViewedNotificationTime = (userId) => {
    try {
        const key = userId
            ? `last_viewed_notification_timestamp_${userId}`
            : 'last_viewed_notification_timestamp'
        const val = localStorage.getItem(key)
        return val ? Number(val) : 0
    } catch (_) {
        return 0
    }
}

export const setLastViewedNotificationTime = (userId, timestamp = Date.now()) => {
    try {
        const key = userId
            ? `last_viewed_notification_timestamp_${userId}`
            : 'last_viewed_notification_timestamp'
        localStorage.setItem(key, String(timestamp))
        localStorage.setItem('last_viewed_notification_timestamp', String(timestamp))
    } catch (_) {}
}

export const getLastViewedNotificationId = (userId) => {
    try {
        const key = userId
            ? `last_viewed_notification_id_${userId}`
            : 'last_viewed_notification_id'
        return localStorage.getItem(key) || ''
    } catch (_) {
        return ''
    }
}

export const setLastViewedNotificationId = (userId, id) => {
    try {
        if (id !== undefined && id !== null) {
            const key = userId
                ? `last_viewed_notification_id_${userId}`
                : 'last_viewed_notification_id'
            localStorage.setItem(key, String(id))
            localStorage.setItem('last_viewed_notification_id', String(id))
        }
    } catch (_) {}
}

export {
    getExpiryTime,
    setExpiryTime,
    getRecentSearches,
    addRecentSearch,
    clearRecentSearches,
    removeRecentSearch,
    setUserTheme,
    getUserTheme,
    setGuestUser,
    getGuestUser,
    setRecaptcha,
    getRecaptcha,
    getUserLanguage,
    setUserLanguage,
    setShowInviteLangPopup,
    getShowInviteLangPopup
}

